<span  class="text-center" alt="Image Source" *ngIf="!loading && imageSource" [innerHTML]="imageSource"></span>
<span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
